import { SeuEnvironment } from '@seu-types';

export const SEU_ENVIRONMENT: SeuEnvironment = {
  production: true,
  env: 'prod',
  apiUrl: 'https://api.processdesigner.scheuch.com',
  msal: {
    clientId: '723efc9d-ed2c-4de4-aa8a-39ba8804c097',
    authority:
      'https://login.microsoftonline.com/a2fcf037-4226-400e-8442-294f22277f3b',
    redirectUrl: {
      cdnUrl: 'https://processdesigner.scheuch.com/',
      azureUrl: 'https://scheuchpdprodstoreweb.z6.web.core.windows.net/',
    },
  },
  isEnvSwitchAllowed: true,
  mock: false,
  sentryEnabled: true,
};
